<template>
  <br><br>
  <div class="div_box">

    <br>
  
      <br>
    <p>
    <label class="form__label"> {{  message }}
      <br>
      <br>
    </label> 
    </p>

    <p>
    <label class="font_12">Total players today:  {{  totalPlayes }}
      <br>
      <br>
    </label> 
    </p>
 
<table id="myTable" class="styled-table">

  

  <th>Ranking</th>
              <th>NFT</th>
              <th>Nickname</th>
              <th>Amount</th>
        

</table>

  </div>
</template>

<script>

//import firebase from "firebase/compat/app"
//import "firebase/compat/auth"

//import { getDatabase, ref, child, get } from "firebase/database";
//import { getDatabase, ref, onValue} from "firebase/database";

//import { getDatabase } from "firebase/database";
import { getDatabase, ref, onValue} from "firebase/database";
//import { getSystemErrorMap } from "util";
//const { ethereum } = window


const firebaseConfig = {
  apiKey: "AIasdwAB8ajEH-dDoMUa3rthcU_SV3ewd59Ah5I",
  authDomain: "erfc-167e3.firebaseapp.com",
  databaseURL: "https://erfc-167e3-default-rtdb.firebaseio.com",
  projectId: "erfc-167e3",
  storageBucket: "erfc-167e3.appspot.com",
  messagingSenderId: "1058954598161",
  appId: "1:1058916125451:web:5ac81b720a35322bb9b788",
  measurementId: "G-8MYX8DRJG"
};

console.log(firebaseConfig);
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore();

export { auth, db };

import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
//import { Console } from "console";



require("firebase/database");
export default {
  name: "SignUp"
  , data() {
      return {
        message: "",
        totalPlayes: 0,
      }}
    ,methods: {
    googleSignIn: function() {
      
    

    //  let provider = new firebase.auth.GoogleAuthProvider();
      //console.log(provider);

      const database = getDatabase();


      
      
              var trContent = [];

              const starCountRef = ref(database, 'ranking/ranking');
              onValue(starCountRef, (snapshot) => {
                try{
                  //const data = snapshot.val();
                  //console.log("Data: "+ JSON.stringify(data));
                  //this.message = JSON.stringify(data) ;
                  trContent = [];
                  
                  this.message = "";
                  snapshot.forEach(function(childSnapshot) {
                    
                        var key = childSnapshot.key;
                        var childData = childSnapshot.val();
                       
                    
                        trContent.push( [ parseInt(key) +1,childData["nickName"],childData["nftId"],childData["amount"].toFixed(2)]);


                    });


                  this.totalPlayes = 0;

                  trContent.reverse();
                  this.totalPlayes = trContent.length;
                  console.log("Data: "+ JSON.stringify(trContent));

                  console.log("trContent.length: " + trContent.length);
                  for (var i = 0; i < trContent.length ; i++) {


                            console.log(i);

                            console.log( "0:"+( trContent[i][1]));

                            var table = document.getElementById("myTable");


                            var row;
                            
                            var cell1;
                            var cell2;
                            var cell3;
                            var cell4;


                            row = table.insertRow(0);
                            
                            cell1 = row.insertCell(0);
                            cell2 = row.insertCell(1);
                            cell3 = row.insertCell(2);
                            cell4 = row.insertCell(3);

                            
                            cell1.innerHTML = trContent[i][0];

                            if (trContent[i][2] == 0){
                              cell2.innerHTML = '<img src="https://erfc-marketplace.web.app/img/nft0.39ad976e.jpg" height="70" width="50">'; 
                            }else if (trContent[i][2] == 1){
                              cell2.innerHTML = '<img src="https://erfc-marketplace.web.app/img/nft1.9755a2e3.jpg" height="70" width="50">'; 
                            }else if (trContent[i][2] == 2){
                              cell2.innerHTML = '<img src="https://erfc-marketplace.web.app/img/nft2.66e7d6e4.jpg" height="70" width="50">'; 
                            }else{
                              cell2.innerHTML = '<img src="https://erfc-marketplace.web.app/img/p2enft.bf50754c.jpg" height="70" width="50">'; 
                            }
                            
                            cell3.innerHTML = trContent[i][1];
                            cell4.innerHTML = trContent[i][3];
                            

                  }

          
                              row = table.insertRow(0);
                            
                              cell1 = row.insertCell(0);
                              cell2 = row.insertCell(1);
                              cell3 = row.insertCell(2);
                              cell4 = row.insertCell(3);

                              
                              cell1.innerHTML = "";
                              cell2.innerHTML = ""; 
                              cell3.innerHTML = "";
                              cell4.innerHTML = "";
                              
                              
          

                } catch (error){ 
                  console.log('Error: ' + error)
            
                  

                  
                }
              });




      
        }

      },beforeMount() {
        this.googleSignIn();
          
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 1.2rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}

.form__input {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 20%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}


.form__input_label {
  font-family: 'Roboto', sans-serif;
  color: rgba(85, 85, 204, 0);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 20%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}


.form__input_text_big {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 40%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}

.form__input:placeholder-shown + .form__label {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateY(-4rem);
  transform: translateY(-4rem);
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  font-size: 62,5%;
}

.div_box {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  border: 0.05rem;
  width: 50%;
  display: block;
  
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}

.button-36 {
  background-image: linear-gradient(92.88deg, #455EB5 9.16%, #5643CC 43.89%, #673FD7 64.72%);
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  flex-shrink: 0;
  font-family: "Inter UI","SF Pro Display",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif;
  font-size: 16px;
  font-weight: 500;
  height: 4rem;
  padding: 0 1.6rem;
  text-align: center;
  text-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;
  transition: all .5s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-36:hover {
  box-shadow: rgba(80, 63, 205, 0.5) 0 1px 30px;
  transition-duration: .1s;
}

@media (min-width: 768px) {
  .button-36 {
    padding: 0 2.6rem;
  }
}


.styled-table {
    border-collapse: collapse;
    margin: 25px 0;
    font-size: 1.2em;
    font-family: sans-serif;
    min-width: 80%;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}
.styled-table thead tr {
    background-color: #009879;
    color: #ffffff;
    text-align: left;
}
.styled-table th{
  font-size: 1.1em;
    font-family: sans-serif;
    padding-bottom: 5%;
}
.styled-table td {
    padding: 12px 15px;
}
.styled-table tbody tr {
    border-bottom: 1px solid #dddddd;
}

.styled-table tbody tr:nth-of-type(even) {
    background-color: #f3f3f3;
}

.styled-table tbody tr:last-of-type {
    border-bottom: 2px solid #009879;
}
.styled-table tbody tr.active-row {
    font-weight: bold;
    color: #009879;
}

.cellStyle{
     border: 1px solid black;
     background-color: #00FF00;
}

.font_12{
  font-size: 1.8em;
    font-family: sans-serif;
}

</style>
